export function getDomainFromUrl(url?: string | null) {
  if (!url) return ''
  try {
    const urlObject = new URL(url);
    const domain = urlObject.hostname
    return domain
  } catch (error) {
    return ''
  }
}